import { render, staticRenderFns } from "./wxuser.vue?vue&type=template&id=369c2c7a&"
import script from "./wxuser.vue?vue&type=script&lang=js&"
export * from "./wxuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports